import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading, Text, Button } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import AlternativeStoreSuggestionsContainer from '../AlternativeStoreSuggestions/AlternativeStoreSuggestionsContainer.js';
import AvailabilityCalendarContainer from '../AvailabilityCalendar/AvailabilityCalendarContainer.js';
import AppointmentInfoContainer from '../LinkedAppointmentInfo/LinkedAppointmentInfoContainer.js';
import NoTimeSlotsContainer from '../NoTimeSlots/NoTimeSlotsContainer.js';
import { Variant } from '../NoTimeSlots/types.js';
import PreferredTimeContainer from '../PreferredTime/PreferredTimeContainer.js';
import SelectedChoicesContainer from '../SelectedChoices/SelectedChoicesContainer.js';
import TimeSlotsContainer from '../TimeSlots/TimeSlotsContainer.js';

const AppointmentDateTime = (_param)=>{
    var { className , labels , calendarLoading , calendarWeekCount , calendarWeekDate , calendarAvailability , calendarClosedDates , store , appointmentType , shouldRequestAlternativeStoreSuggestions =false , selectedDate , onCalendarWeeksChange , onSelectDate , timeSlotsLoading , noTimeSlotsVariant , timeSlots , showOtherTimeSlots , otherTimeSlots , onSelectTime , onToggleOtherTimeSlots , nextAvailableDate , noMoreAvailabilityUntilDate , noTimeSlotsAction , onSelectStore , onPreferredTimeClick , onPreferredTimeFilterClick , isAabAlternativeStoreAvailabilityEnabled =false , hasNoTimeSlotsAvailableInCalendar , isVirtualappointment , otherTimeSlotsElement  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "calendarLoading",
        "calendarWeekCount",
        "calendarWeekDate",
        "calendarAvailability",
        "calendarClosedDates",
        "store",
        "appointmentType",
        "shouldRequestAlternativeStoreSuggestions",
        "selectedDate",
        "onCalendarWeeksChange",
        "onSelectDate",
        "timeSlotsLoading",
        "noTimeSlotsVariant",
        "timeSlots",
        "showOtherTimeSlots",
        "otherTimeSlots",
        "onSelectTime",
        "onToggleOtherTimeSlots",
        "nextAvailableDate",
        "noMoreAvailabilityUntilDate",
        "noTimeSlotsAction",
        "onSelectStore",
        "onPreferredTimeClick",
        "onPreferredTimeFilterClick",
        "isAabAlternativeStoreAvailabilityEnabled",
        "hasNoTimeSlotsAvailableInCalendar",
        "isVirtualappointment",
        "otherTimeSlotsElement"
    ]);
    const intl = useIntl();
    const { dateTime: { formatDate  } ,  } = intl;
    const hasTimeSlots = timeSlots.length > 0;
    const hasOtherTimeSlots = otherTimeSlots.length > 0;
    const noTimeSlotsComponent = hasNoTimeSlotsAvailableInCalendar ? /*#__PURE__*/ React.createElement(NoTimeSlotsContainer, {
        variant: noTimeSlotsVariant,
        action: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noAvailabilityUntilDate: noMoreAvailabilityUntilDate
    }) : null;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-date-time', className)
    }), /*#__PURE__*/ React.createElement(SelectedChoicesContainer, null), /*#__PURE__*/ React.createElement(AppointmentInfoContainer, null), /*#__PURE__*/ React.createElement(Heading, {
        component: "h3",
        variant: "smallest",
        className: "appointment-date-time__title"
    }, labels.title), /*#__PURE__*/ React.createElement(PreferredTimeContainer, {
        onPreferredTimeClick: onPreferredTimeClick,
        onPreferredTimeFilterClick: onPreferredTimeFilterClick,
        calendar: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(AvailabilityCalendarContainer, {
            "aria-controls": "appointment-date-time__timeslots",
            loading: calendarLoading,
            weekCount: calendarWeekCount,
            weekDate: calendarWeekDate,
            availability: calendarAvailability,
            closedDates: calendarClosedDates,
            selectedDate: selectedDate,
            onChangeWeeks: onCalendarWeeksChange,
            onSelectDate: onSelectDate,
            noTimeSlots: noTimeSlotsComponent
        }), selectedDate && !hasNoTimeSlotsAvailableInCalendar && /*#__PURE__*/ React.createElement(Text, {
            className: "appointment-date-time__selected-date"
        }, formatDate(selectedDate, 'long')))
    }), /*#__PURE__*/ React.createElement("section", {
        id: "appointment-date-time__timeslots",
        "aria-live": "polite"
    }, noTimeSlotsVariant === Variant.none ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "appointment-date-time__section-title"
    }, labels.selectATime), /*#__PURE__*/ React.createElement("p", {
        className: "appointment-date-time__section-subtitle"
    }, labels.selectATimeSubtitle), /*#__PURE__*/ React.createElement(TimeSlotsContainer, {
        loading: timeSlotsLoading || calendarLoading,
        slots: timeSlots,
        onSelectTime: onSelectTime
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, !hasNoTimeSlotsAvailableInCalendar ? /*#__PURE__*/ React.createElement(Alert, {
        className: "alert-m-default no-time-slots",
        variant: noTimeSlotsVariant === Variant.error ? 'warning' : 'info'
    }, /*#__PURE__*/ React.createElement(NoTimeSlotsContainer, {
        variant: noTimeSlotsVariant,
        action: noTimeSlotsAction,
        nextAvailableDate: nextAvailableDate,
        noAvailabilityUntilDate: noMoreAvailabilityUntilDate
    })) : null), hasOtherTimeSlots && /*#__PURE__*/ React.createElement(React.Fragment, null, hasTimeSlots && /*#__PURE__*/ React.createElement(Button, {
        className: "appointment-date-time__show-other-time-slots",
        variant: "ghost",
        onClick: onToggleOtherTimeSlots
    }, showOtherTimeSlots ? labels.hideOtherTimeSlots : labels.showOtherTimeSlots), showOtherTimeSlots && /*#__PURE__*/ React.createElement("div", {
        ref: otherTimeSlotsElement,
        className: "appointment-date-time__other-time-slots"
    }, !hasTimeSlots && /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "appointment-date-time__section-title"
    }, labels.otherTimeSlots), /*#__PURE__*/ React.createElement(TimeSlotsContainer, {
        loading: timeSlotsLoading || calendarLoading,
        slots: otherTimeSlots,
        onSelectTime: onSelectTime
    })))), isAabAlternativeStoreAvailabilityEnabled && !isVirtualappointment && /*#__PURE__*/ React.createElement("section", {
        id: "appointment-date-time__alternative-store-suggestions",
        className: "appointment-date-time__with-secondary-background",
        "aria-live": "polite"
    }, /*#__PURE__*/ React.createElement(AlternativeStoreSuggestionsContainer, {
        selectedStore: store !== null && store !== void 0 ? store : undefined,
        selectedDate: selectedDate,
        requestStoresFromParent: shouldRequestAlternativeStoreSuggestions,
        onClickStore: onSelectStore
    })));
};

export { AppointmentDateTime as default };
//# sourceMappingURL=AppointmentDateTime.js.map
